import React from "react";
import classNames from "classnames";
import { Theme, makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import SearchIcon from "@material-ui/icons/SearchOutlined";

export const estilosEstadoVazio = (theme: Theme): any => ({
  raiz: {
    minHeight: 280,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(5, 2),
    color: theme.palette.text.secondary,
    // no desktop a tabela vazia ficava espremida no topo com metade da tela sobrando
    [theme.breakpoints.up("md")]: {
      minHeight: "max(280px, calc(var(--altura-tela, 100vh) - 420px))"
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: 180,
      padding: theme.spacing(3, 2)
    }
  },
  // tabelas pequenas dentro de formulario nao podem herdar a altura de tela cheia
  compacta: {
    minHeight: 150,
    padding: theme.spacing(3, 2),
    [theme.breakpoints.up("md")]: { minHeight: 150 },
    [theme.breakpoints.down("sm")]: { minHeight: 130 }
  },
  icone: {
    fontSize: 56,
    opacity: 0.3,
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: { fontSize: 40 }
  },
  titulo: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  iconeCompacto: {
    fontSize: 34,
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: { fontSize: 30 }
  },
  apoio: {
    marginTop: theme.spacing(0.5),
    maxWidth: 380,
    textAlign: "center"
  }
});

type ChaveEstilo = "raiz" | "compacta" | "icone" | "iconeCompacto" | "titulo" | "apoio";

const useStyles = makeStyles<Theme, {}, ChaveEstilo>(estilosEstadoVazio, { name: "EstadoVazio" });

interface Props {
  titulo?: string;
  apoio?: string;
  compacto?: boolean;
}

// a tabela renderiza este conteudo dentro de um Typography (elemento de texto), entao
// tudo aqui precisa ser inline: uma div invalidaria a marcacao
const EstadoVazioTabela = ({
  titulo = "Nenhum resultado encontrado",
  apoio = "Revise os filtros aplicados e pesquise novamente.",
  compacto = false
}: Props) => {
  const classes = useStyles();
  return (
    <span className={classNames(classes.raiz, compacto && classes.compacta)}>
      <SearchIcon className={classNames(classes.icone, compacto && classes.iconeCompacto)} />
      <Typography component="span" variant="subtitle1" className={classes.titulo}>
        {titulo}
      </Typography>
      <Typography component="span" variant="body2" className={classes.apoio}>
        {apoio}
      </Typography>
    </span>
  );
};

export default EstadoVazioTabela;
